'use strict';

var ALIGN = {
    LEFT: 'left',
    RIGHT: 'right',
    CENTER: 'center'
};

ALIGN.DEFAULT = ALIGN.LEFT;

module.exports = ALIGN;


//////////////////
// WEBPACK FOOTER
// ../node_modules/slate-edit-table/dist/ALIGN.js
// module id = 175
// module chunks = 0